import { getPlateCssBlobUrl } from '../services/plateCssService'
import sanitizedHtml from './sanitizeHtml'
// All plate generated html is used in the shadow DOM to avoid style conflicts with the host page,
// but to work properly we need to redefine some Tailwind variables to have a fixed value instead of being related to the host page font-size.
// This is the list of variables that we re-define for plate content
const replacedTWVarsForPlateGeneratedHTML = `:host {
  --tw-divide-y-reverse: 0;
  --tw-border-style: solid;
  --tw-font-weight: initial;
  --tw-tracking: initial;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate-x: rotateX(0);
  --tw-rotate-y: rotateY(0);
  --tw-rotate-z: rotateZ(0);
  --tw-skew-x: skewX(0);
  --tw-skew-y: skewY(0);
  --tw-space-x-reverse: 0;
  --tw-gradient-position: initial;
  --tw-gradient-from: #0000;
  --tw-gradient-via: #0000;
  --tw-gradient-to: #0000;
  --tw-gradient-stops: initial;
  --tw-gradient-via-stops: initial;
  --tw-gradient-from-position: 0%;
  --tw-gradient-via-position: 50%;
  --tw-gradient-to-position: 100%;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-color: initial;
  --tw-inset-shadow: 0 0 #0000;
  --tw-inset-shadow-color: initial;
  --tw-ring-color: initial;
  --tw-ring-shadow: 0 0 #0000;
  --tw-inset-ring-color: initial;
  --tw-inset-ring-shadow: 0 0 #0000;
  --tw-ring-inset: initial;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-blur: initial;
  --tw-brightness: initial;
  --tw-contrast: initial;
  --tw-grayscale: initial;
  --tw-hue-rotate: initial;
  --tw-invert: initial;
  --tw-opacity: initial;
  --tw-saturate: initial;
  --tw-sepia: initial;
  --tw-drop-shadow: initial;
  --tw-duration: initial;
  --tw-ease: initial;
  /* To use in shadow DOM we need to re-define custom properties to px 
    in order to not be related to the html element font-size */
  --radius: 10px;
  --spacing: 4px;
  --container-xs: calc(var(--spacing) * 20);
  --container-sm: calc(var(--spacing) * 24);
  --container-md: calc(var(--spacing) * 28);
  --container-lg: calc(var(--spacing) * 32);
  --text-xs: calc(var(--text-base) * 0.75);
  --text-xs--line-height: calc(1 / 0.75);
  --text-sm: calc(var(--text-base) * 0.875);
  --text-sm--line-height: calc(1.25 / 0.875);
  --text-base: calc(var(--spacing) * 4);
  --text-base--line-height: calc(1.5 / 1);
  --text-lg: calc(var(--text-base) * 1.125);
  --text-lg--line-height: calc(1.75 / 1.125);
  --text-xl: calc(var(--text-base) * 1.25);
  --text-xl--line-height: calc(1.75 / 1.25);
  --text-2xl: calc(var(--text-base) * 1.5);
  --text-2xl--line-height: calc(2 / 1.5);
  --text-3xl: calc(var(--text-base) * 1.875);
  --text-3xl--line-height: calc(2.25 / 1.875);
  --text-4xl: calc(var(--text-base) * 2.25);
  --text-4xl--line-height: calc(2.5 / 2.25);
  --text-5xl: calc(var(--text-base) * 3);
  --text-5xl--line-height: calc(1 / 3);
  --text-6xl: calc(var(--text-base) * 3.75);
  --text-6xl--line-height: calc(1 / 3.75);
}`

export default async function insertContentWithStyles(htmlString: string, shadowRoot: ShadowRoot) {
  const container = document.createElement('div')
  container.innerHTML = sanitizedHtml(htmlString)

  if (htmlString.includes('data-slate-editor="true"')) {
    const blobUrl = await getPlateCssBlobUrl()

    shadowRoot.innerHTML = ''

    const linkEl = document.createElement('link')
    const styleEl = document.createElement('style')

    linkEl.rel = 'stylesheet'
    linkEl.href = blobUrl

    styleEl.textContent = replacedTWVarsForPlateGeneratedHTML

    shadowRoot.appendChild(linkEl)
    shadowRoot.appendChild(styleEl)
    insertHtml()
  } else {
    shadowRoot.innerHTML = ''
    insertHtml()
  }

  function insertHtml() {
    const styles = document.createElement('style')
    styles.textContent = `
          img, video, iframe, figure {
            max-width: 100% !important;  
          }
        `
    shadowRoot.appendChild(styles)
    shadowRoot.appendChild(container)
  }
}
